import { render, staticRenderFns } from "./AAsignacionTablac.vue?vue&type=template&id=9c25bd34"
import script from "./AAsignacionTablac.vue?vue&type=script&lang=js"
export * from "./AAsignacionTablac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports